let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("fgDbI")).then(() => parcelRequire('3GKz4'));